<div class="row mt-2">
  <div class="col-12">
    <div class="table-responsive">
      <table class="table casino" *ngIf="Data?.profit_sharing.length != 0">
        <thead>
          <tr>
            <th style="width: 150px">{{ "GAME_LOGO" | translate }}</th>
            <th style="width: 200px">{{ "STATUS" | translate }}</th>
            <th style="width: 350px">{{ "PLACE_TO_FIGHT" | translate }}</th>
            <th>{{ "LIMIT_PLAY" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let setting of Data.profit_sharing; let i = index">
            <tr>
              <td style="width: 150px; position: relative">
                <img
                  [src]="setting.game_logo | imgHost"
                  [alt]="setting.game_code"
                  style="width: 116px; padding: 5px"
                  class="img-logo-shadow bg-primary rounded"
                />
                <small class="d-block opacity-50">{{ setting.game_code }}</small>
              </td>
              <td style="width: 200px">
                <div class="form-check form-check-inline text-danger">
                  <input
                    id="game_disable_{{ i }}"
                    type="radio"
                    class="form-check-input"
                    name="game_disable_{{ i }}"
                    [value]="false"
                    [(ngModel)]="setting.game_enable"
                  />
                  <label for="game_disable_{{ i }}" class="form-check-label">
                    {{ "DISABLE" | translate }}
                  </label>
                </div>
                <div class="form-check form-check-inline text-primary">
                  <input
                    id="game_enable_{{ i }}"
                    type="radio"
                    class="form-check-input"
                    name="game_enable_{{ i }}"
                    [value]="true"
                    [(ngModel)]="setting.game_enable"
                  />
                  <label for="game_enable_{{ i }}" class="form-check-label">
                    {{ "ENABLE" | translate }}
                  </label>
                </div>
              </td>

              <td class="text-end" >
                <small class="d-block opacity-50">
                  {{ "RECEIVED" | translate }} = {{ setting.percent_parent }}%
                </small>
                <div class="d-flex">
                  <div class="input-group me-1">
                    <span class="input-group-text">
                      {{ "PLACE_TO_FIGHT" | translate }}
                    </span>
                    <input
                      type="number"
                      class="form-control text-end"
                      [(ngModel)]="setting.percent_own"
                      (ngModelChange)="onChangePercent(setting.game_code)"
                      (keyup)="onChangePercent(setting.game_code)"
                      (keydown)="onChangePercent(setting.game_code)"
                      (keypress)="onChangePercent(setting.game_code)"
                      [max]="setting.percent_given"
                      step="0.5"
                      min="0"
                    />
                    <span class="input-group-text">%</span>
                  </div>
                  <div class="input-group">
                    <span class="input-group-text">
                      {{ "RELEASE" | translate }}
                    </span>
                    <input
                      type="number"
                      class="form-control text-end"
                      [value]="setting.percent_given"
                      readonly
                    />
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </td>

              <!-- betlimit casino -->
              <td class="text-end">
                <ng-container *ngIf="!setting.casino_betlimit?.list">
                  <div class="text-center opacity-50">CAN'T CUSTOM BETLIMIT</div>
                </ng-container>
                <ng-container *ngIf="setting.casino_betlimit?.list">
                  <small class="d-block">
                    {{
                      "THE_BET_SHOULD_NOT_BE_LESS_THAN_AMOUNT_CURRENCY"
                        | translate
                          : {
                              amount: setting?.casino_betlimit?.selected?.min || 0,
                              currency: "THB"
                            }
                    }}
                  </small>
                  <select
                    *ngIf="setting.casino_betlimit?.selected && setting.casino_betlimit?.list"
                    class="form-select"
                    [(ngModel)]="setting.casino_betlimit.selected.limit_name"
                    (ngModelChange)="onChangeCasinoBetlimt(casinoBetlimit.value, setting.game_code)"
                    #casinoBetlimit
                  >
                    <option value disabled>เลือก...</option>
                    <ng-container *ngFor="let item of setting.casino_betlimit?.list">
                      <option *ngIf="item.prod == prod" [value]="item.limit_name">
                        {{ item.limit_name }} {{ item.Description }}
                      </option>
                    </ng-container>
                  </select>
                  <small class="d-block">
                    {{
                      "BETS_SHOULD_NOT_EXCEED_AMOUNT_CURRENCY"
                        | translate
                          : {
                              amount: setting?.casino_betlimit?.selected?.max || 0,
                              currency: "THB"
                            }
                    }}
                  </small>
                </ng-container>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <ng-container *ngIf="Data?.length == 0">
        <div class="no-data casino" style="border-style: dashed">
          {{ "NOT_FOUND_PROVIDER_GAME" | translate }}
        </div>
      </ng-container>
    </div>
  </div>
</div>
